import { Column } from 'typeorm'

export class VariableFields {
  @Column('json', { name: 'var_fields', nullable: true })
  fields: object | null
}
